export default class ThematicGroupService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/thematicGroups/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/thematicGroups', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/thematicGroups', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('me/thematicGroups/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/thematicGroups/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ThematicGroupService.js